module.exports = __webpack_public_path__ + "static/media/logo.da774c09.png";